import React, { useState, useEffect, memo } from 'react';
import { db, collection, onSnapshot } from '../../config/firebase';
import {TbHomeDollar} from 'react-icons/tb';
import {FaBusinessTime} from 'react-icons/fa';
import {GiTakeMyMoney} from 'react-icons/gi';

 function PaymentCount() {
  const [data, setData] = useState([]);

  useEffect(() => {
    const unsubscribe = onSnapshot(collection(db, 'Payment'), (snapshot) => {
      setData(snapshot.docs.map((doc) => doc.data()));
    });
    return () => unsubscribe();
  }, []);

  const getStatusCount = (status) => {
    if (status === 'Total') {
      return data.length;
    } else {
      return data.filter((item) => item.status === status).length;
    }
  };

  return (
    <div className="grid grid-cols-1  mt-[60px] sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
    {[{ name :'Total',icon:<TbHomeDollar color='purple'  size={'30'}  />}, {name:'Verified',icon:<GiTakeMyMoney color='purple'  size={'30'} />}, {name:'Unverified',icon:<FaBusinessTime  color='purple'  size={'30'}/>}].map((status, index) => (
        <div
          key={index}
          className="flex items-center justify-center h-auto rounded bg-gray-50 dark:bg-gray-800 shadow-lg bg-sky-500/100"
        >
          <div className="border-2 border-gray-200 px-4 py-6 rounded-lg w-full flex justify-center flex-col items-center">
            {status.icon}
            <h2 className="title-font font-medium text-3xl text-gray-900 mt-5 ">
              {getStatusCount(status.name)}
            </h2>
            <p className="leading-relaxed">{`${status.name} Payments`}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
export default memo(PaymentCount)